<template>
  <div class="px-8">
    <header class="my-4">
      <h4 class="font-weight-bold">Explore more from Maropost
      </h4>
    </header>
    <v-container class="px-0 mb-12" fluid>
      <v-row>
        <v-col 
          cols="12" 
          md="6" 
          lg="4" 
          v-for="explore in exploreMore" 
          :key="explore.title"
        >
          <v-card 
            class="service-card" 
            flat 
            :elevation="0"
          >
            <v-card-text class="text-left pa-2 pb-12 card-bg">
              <v-img
                :max-width="80"
                contain
                :src="maropostLogoUrl"
                class="mr-3 pt-5"
              />
              <h2 class="font-weight-bold mb-2">{{ explore.title }}</h2>
              <v-divider class="mb-4" />
              <p class="sub-title-2 mb-4 pr-6">{{ explore.description }}</p>

              <div class="d-flex flex-column flex-md-row justify-space-around">
                <div class="flex-shrink-0 mr-4">
                  <v-img 
                    :src="explore.image" 
                    :alt="`${explore.title} illustration`"
                    width="157" 
                    height="120"
                    class="mr-2"
                  />
                </div>

                <v-list density="compact" class="text-left" style="background: transparent;">
                  <v-list-item 
                    v-for="(feature, index) in explore.features" 
                    :key="`${explore.title}-${index}`"
                    class="pa-0 mb-1"
                    :min-height="28"
                  >
                    <template v-slot:prepend>
                      <v-icon 
                        size="x-small" 
                        color="#545C6C"
                        class="mr-2"
                      >
                        mdi-circle
                      </v-icon>
                    </template>
                    <v-list-item-title class="text-body-2">
                      {{ feature.title }}
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item class="px-0 mt-5">
                    <v-btn
                      :href="explore.action.link"
                      target="_blank"
                      base-color="black"
                      class="font-weight-bold text-none"
                      variant="elevated"
                    >
                      {{ explore.action.title }}
                    </v-btn>
                  </v-list-item>
                </v-list>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">

// --------------------------------------------------
// Imports
// --------------------------------------------------
import maropostLogoUrl from '@/assets/maropost-logo.svg'
import { EXPLORE_MORE_PRODUCTS } from '@/constants/productExplore.constants'

// --------------------------------------------------
// Data
// --------------------------------------------------
const exploreMore = EXPLORE_MORE_PRODUCTS
</script>

<style scoped>
  .service-card {
    min-height: 400px;
  }
  .card-bg {
    background: url('../../../assets/images/explore/explore-more-bg.png') no-repeat center center;
    background-size: cover;
    height: 100%;
    width: 100%;
  }
  .sub-title-2 {
    font-weight: 400;
    font-size: 26px;
    line-height: 36px;
    letter-spacing: 0.15px;
    color: #141414;
    min-height: 70px;
}
</style>

